import React, { useState } from "react";
import axios from "axios"

function Weather() {

    return(
        <div style={{textAlign:'center'}}>
            
            ___________________________________

            <div>
                <br></br>
                <div style={{fontSize:'14px', fontWeight:'bold', marginBottom:'10px'}}>사용 기술</div>
                <div style={{fontSize:'13px'}}>Redux Toolkit</div>                
                <div style={{fontSize:'13px'}}>useSelector, useNavigator</div>                
                <div style={{fontSize:'13px'}}>useState, useDispatch</div>
                <div style={{fontSize:'13px'}}>useEffect, localStorage</div>
                <div style={{fontSize:'13px'}}>Route, URL Prams</div>
                <div style={{fontSize:'13px'}}>sessionStorage</div>
                <br></br>
                ___________________________________

                <br></br>
                <br></br>
                <div style={{fontSize:'13px'}}>회원가입 정보와 포스트 정보는</div>   
                <div style={{fontSize:'13px'}}>Redux, sessionStorage, localStorage에 저장됩니다.</div>  
                <div style={{fontSize:'13px'}}>로그아웃을 누를 경우 세션이 해제되며,</div>  
                <div style={{fontSize:'13px'}}>localStorage 값은 사라지지 않습니다.</div> 
                <div style={{fontSize:'13px'}}>편의상 한 개의 아이디만 가입 가능합니다.</div> 


            </div>

            {/* <button onClick={()=>{ 

            }}>날씨버튼</button>
         */}
        
        
        </div>
    )
}

export default Weather